/* 🤖 this file was generated by svg-to-ts */
export const iconPhantomwallet: {
  name: 'phantomwallet';
  data: string;
} = {
  name: 'phantomwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M8.52 12.81c-.78 0-1.42.63-1.42 1.41v2.28c0 .77.64 1.41 1.42 1.41s1.42-.63 1.42-1.41v-2.28c0-.77-.64-1.41-1.42-1.41m4.94 0c-.78 0-1.42.63-1.42 1.41v2.28c0 .77.64 1.41 1.42 1.41s1.42-.63 1.42-1.41v-2.28c0-.77-.64-1.41-1.42-1.41"/><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m-.25 27H15C9.06 27 3.48 21.89 3.6 16.01c.11-5.69 4.81-10.26 10.59-10.26s10.59 4.69 10.59 10.48h2.86c.94 0 1.67.86 1.47 1.77-1.1 4.94-8.12 9-13.36 9"/></svg>`,
};
